/**
 * Consolidated exam + practice logic for CBR AI learning app.
 * Used by AI Exam results, Practice flow, and weak area identification.
 */

export const PASS_THRESHOLD = 70;

export function calculateScore(correct: number, total: number): number {
  return total === 0 ? 0 : Math.round((correct / total) * 100);
}

export interface TopicResult {
  topic: string;
  correct: number;
  total: number;
}

export interface WeakArea {
  topic: string;
  score: number;
}

export function identifyWeakAreas(results: TopicResult[]): WeakArea[] {
  return results
    .map((r) => ({ topic: r.topic, score: calculateScore(r.correct, r.total) }))
    .filter((r) => r.score < PASS_THRESHOLD)
    .slice(0, 3);
}

export function getScoreColor(score: number): string {
  if (score >= 80) return 'green';
  if (score >= 70) return 'orange';
  return 'red';
}
